import { render, staticRenderFns } from "./Blog.vue?vue&type=template&id=3d04bb48&"
import script from "./Blog.ts?vue&type=script&lang=ts&"
export * from "./Blog.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports